/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_New_VersionInputs */

const da_app_new_version = /** @type {(inputs: App_New_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der er kommet en ny version af AImforA.`)
};

/** @type {(inputs: App_New_VersionInputs) => LocalizedString} */
const en_app_new_version = da_app_new_version;

/**

* @param {App_New_VersionInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const app_new_version = /** @type {((inputs?: App_New_VersionInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_New_VersionInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_new_version(inputs)
	return /** @type {LocalizedString} */ ("Der er kommet en ny version af AImforA.")
});